import { Children, FC } from 'react';
import { useTheme } from 'styled-components';

import { ThemeProps } from '@core/type';

import { Grid } from '../grid/Grid';
import { Box } from '../layout/Box';
import { TableRowProps } from './interface-table';

export const TableRow: FC<TableRowProps> = ({
  grid: { xs = [], sm = [], md = [], lg = [], xl = [], ...restGridProps },
  isColumn,
  isHeading,
  children,
  ...restProps
}) => {
  const {
    structure: {
      table: { row, heading, grid },
    },
  } = useTheme() as ThemeProps;
  const themeBoxProps = { ...row, ...(isHeading && heading) };

  const childrenWithGrid = Children.toArray(children).map((child, index) => (
    <Grid
      role={isHeading ? 'columnheader' : 'cell'}
      key={index}
      xs={xs[index]}
      sm={sm[index]}
      md={md[index]}
      lg={lg[index]}
      xl={xl[index]}
    >
      {child}
    </Grid>
  ));

  return (
    <Box
      role={'row'}
      display={isHeading && isColumn ? 'none' : 'block'}
      {...themeBoxProps}
      {...restProps}
    >
      <Grid {...grid} {...restGridProps}>
        {childrenWithGrid}
      </Grid>
    </Box>
  );
};
